import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["template", "container", "menu", "menuItemTemplate"]

    connect() {
        console.log("Connecting input advanced nested form...")
        super.connect();
    }

    add(event) {
        event.preventDefault()
        const timestamp = new Date().getTime()
        const menuItemContent = this.menuItemTemplateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
        this.menuTarget.insertAdjacentHTML("beforeend", menuItemContent)
        const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, timestamp)
        this.containerTarget.insertAdjacentHTML("beforeend", content)
        this.#selectLast()
    }

    remove(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".nested-fields")
        const menuItem = this.menuTarget.querySelector(wrapper.dataset.menuItem)
        menuItem.remove()
        if (wrapper.dataset.newRecord === "true") {
            wrapper.remove()
        } else {
            wrapper.querySelector("input[name*='_destroy']").value = 1
            wrapper.classList.add("d-none")
        }
    }

    select(event) {
        event.preventDefault()
        const menuItems = this.menuTarget.querySelectorAll("a")
        menuItems.forEach(menuItem => {
            menuItem.classList.remove('active')
        })
        event.currentTarget.classList.add("active")

        const contents = this.containerTarget.querySelectorAll(".nested-fields")
        contents.forEach(content => {
            content.classList.add("d-none")
        })
        console.log(event.currentTarget.dataset.content)
        const selectedContent = this.containerTarget.querySelector(event.currentTarget.dataset.content)
        selectedContent.classList.remove("d-none")
    }

    #selectLast() {
        const menuItems = this.menuTarget.querySelectorAll("a")
        menuItems.forEach((menuItem, index) => {
            if (index === menuItems.length - 1) {
                menuItem.classList.add("active")
            } else {
                menuItem.classList.remove("active")
            }
        })

        const contents = this.containerTarget.querySelectorAll(".nested-fields")
        contents.forEach((content, index) => {
            if (index === contents.length - 1) {
                content.classList.remove("d-none")
            } else {
                content.classList.add("d-none")
            }
        })
    }

}
